import { render } from "./NextQuestion.vue?vue&type=template&id=2ff144ba&scoped=true"
import script from "./NextQuestion.vue?vue&type=script&lang=js"
export * from "./NextQuestion.vue?vue&type=script&lang=js"

import "./NextQuestion.vue?vue&type=style&index=0&id=2ff144ba&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ff144ba"]])

export default __exports__